






















import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import EnterpriseCard from '@/components/enterprise/EnterpriseCard.vue';
import PublicLayout from '../../views/layouts/PublicLayout.vue';
import FirstBlock from '@/components/home_page/FirstBlock.vue';
import AndroidBlock from '@/components/home_page/AndroidBlock.vue';
import { Enterprise } from '@/resources/enterprise/Enterprise';
import { namespace } from 'vuex-class';
import { GET_ITEM, SHOW_REQUEST } from '@/store';
import { NAMESPACE } from '@/store/models/pub/enterprises';

const store = namespace(NAMESPACE);

@Component({
  components: { FirstBlock, EnterpriseCard, PublicLayout, AndroidBlock }
})
export default class Home extends Mixins<SlotMixin>(SlotMixin) {
  @store.Getter(GET_ITEM) enterprise!: Enterprise;
  @store.Action(SHOW_REQUEST) show:any;

  created () {
    this.show(435);
    this.$gtag.event('page_view', {});
  }
}
